var map = {
	"./en": 2844,
	"./en.js": 2844,
	"./en.json": 10511,
	"./id": 81250,
	"./id.js": 81250,
	"./id.json": 63429,
	"./ja": 3954,
	"./ja.js": 3954,
	"./ja.json": 49173,
	"./ko": 90001,
	"./ko.js": 90001,
	"./ko.json": 87850,
	"./kok": 82444,
	"./kok.js": 82444,
	"./kok.json": 41487,
	"./th": 12295,
	"./th.js": 12295,
	"./th.json": 23840,
	"./zh": 65257,
	"./zh.js": 65257,
	"./zh.json": 48098
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32941;